/**
 * Reveal the finished reservations — lapsed, released and struck out (BON-472).
 *
 * A CHECKBOX BESIDE THE SEARCH BOX, not a button in the action group. It changes
 * what the CSR is looking at and nothing else: no request touches a reservation,
 * nothing is created or destroyed, and flipping it back puts the tab exactly
 * where it was. Drawn as an action it would read like one, on a surface whose
 * other controls all send a customer an email or hand seats back.
 *
 * IT DOES NOT MOVE THE SEATS-HELD FIGURE OR THE TAB BADGE. Both count seats that
 * are actually held, server-side, from the holds table — and every row this
 * reveals is finished and holds none. A CSR sizing up a workshop must not see
 * that number jump because they went looking for history.
 */
export function ReservationsHistoryToggle({
  checked,
  onChange,
}: {
  checked: boolean;
  onChange: (next: boolean) => void;
}) {
  return (
    <label className="flex cursor-pointer select-none items-center gap-2 whitespace-nowrap text-sm text-stone-600 dark:text-stone-300">
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="h-4 w-4 rounded border-stone-300 text-moss-600 focus:ring-moss-500 dark:border-stone-600 dark:bg-[#1e2520]"
      />
      Show finished
    </label>
  );
}
